import { CouponInfo } from '@entities/Loyalty/hooks/useFetchCustomerCoupons'

import { toSafeDate } from '@shared/uttils'

import styles from './CouponsSlider.module.scss'

type CouponsSliderProps = {
  coupons: CouponInfo[]
  loading: boolean
}

export default function CouponsSlider ({ coupons, loading }: CouponsSliderProps) {
  if (loading) {
    return (
      <div className={styles.container}>
        <div className={styles.skeleton} />
        <div className={styles.skeleton} />
        <div className={styles.skeleton} />
      </div>
    )
  }

  if (!coupons || coupons.length === 0) {
    return (
      <div className={styles.container}>
        <div className={styles.empty}>
          <p>У вас пока нет доступных купонов</p>
        </div>
      </div>
    )
  }

  return (
    <div className={styles.container}>
      {coupons.map((coupon) => (
        <div key={coupon.id} className={styles.coupon}>
          {coupon.localInfo?.image?.url && (
            <div className={styles.coupon__image}>
              <img
                src={coupon.localInfo.image.url}
                alt={coupon.localInfo.title}
                loading="lazy"
              />
            </div>
          )}
          <div className={styles.coupon__content}>
            <h4 className={styles.coupon__title}>
              {coupon.localInfo?.title || coupon.name}
            </h4>
            {coupon.localInfo?.shortDescription && (
              <p className={styles.coupon__description}>
                {coupon.localInfo.shortDescription}
              </p>
            )}
            <div className={styles.coupon__meta}>
              <span className={styles.coupon__code}>
                Код: {coupon.code}
              </span>
              {coupon.validTo && ((() => {
                const date = toSafeDate(coupon.validTo)
                return date ? (
                  <span className={styles.coupon__validity}>
                    До {date.toLocaleDateString('ru')}
                  </span>
                ) : null
              })())}
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}